module.exports = "<div id=\"{{id}}\" class=\"collapse\">\n  <slot></slot>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/collapse/collapse.html
// module id = 26
// module chunks = 0